import { isValidElement } from "react";
import throttle from "lodash.throttle";
import shortid from "shortid";
import isEqual from "react-fast-compare";
import { TabStringTitle } from "./components";
import { TabLabelComponent } from "./index";

export const adjustMenu = throttle((element) => {
  const parent = element?.parentElement;

  if (!element || !parent) return;

  const parentRect = parent.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const overflowRight = elementRect.right - window.innerWidth;
  const overflowLeft = elementRect.left;

  if (overflowRight > 0) {
    const newLeft =
      Math.min(
        parentRect.width - elementRect.width,
        element.offsetLeft - overflowRight
      ) + 20;
    element.style.left = `${newLeft}px`;
  } else if (overflowLeft < 0) {
    const newLeft = Math.max(0, element.offsetLeft - overflowLeft);
    element.style.left = `${newLeft}px`;
  }
}, 200);

// export function enrichData(tabs) {
//   if (!tabs) throw new Error("Tabs data is required to render Pills");

//   return tabs.map((tab) => {
//     if (tab.id === undefined) tab.id = shortid.generate();

//     if (typeof tab.tab === "string") {
//       tab.tab = <TabStringTitle>{tab.tab}</TabStringTitle>;
//     } else if (!isValidElement(tab.tab)) {
//       tab.settings = tab.tab;
//       tab.tab = <TabLabelComponent {...tab.tab} />;
//     }
//     return tab;
//   });
// }

export function enrichData(tabs, previous) {
  if (!tabs) throw new Error("Tabs data is required to render Pills");

  return tabs.map((tab, index) => {
    const sameSettings = isEqual(previous?.[index]?.tab, tab.tab);
    const haveId = previous?.[index]?.id !== undefined;
    const haveElm = previous?.[index]?.elm !== undefined;

    if (haveId && haveElm && sameSettings) {
      tab.id = previous[index].id;
      tab.elm = previous[index].elm;

      return tab;
    }

    if (tab.id === undefined) {
      if (previous?.[index]?.id) tab.id = previous[index].id;
      else tab.id = shortid.generate();
    }

    if (typeof tab.tab === "string") {
      tab.elm = <TabStringTitle>{tab.tab}</TabStringTitle>;
    } else if (!isValidElement(tab.tab)) {
      tab.elm = <TabLabelComponent {...tab.tab} />;
    }
    return tab;
  });
}
